import { Autocomplete, Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

import {
  FontStyle,
  QuestionData,
  defaultBottomPadding,
  defaultInnerStyle,
  defaultContainerStyle,
} from "../../constants";
import CheckButton from "../CheckButton";
import HeartButton from "../HeartButton";
import TempDisplay from "../TempDisplay";
import { CustomPaper, StyledTextField } from "../AutocompleteUtils";
import HeartButtonTwoStep from "../HeartButtonTwoStep";

const styles = {
  container: {
    ...defaultContainerStyle,
  },
  inner: {
    ...defaultInnerStyle,
  },
  body: {
    ...FontStyle.body,
    fontSize: "1rem",
    textAlign: "center",
    lineHeight: "1.4",
    maxWidth: "500px",
  },
  search: {
    width: "100%",
    maxWidth: "500px",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "4px",
    border: "1px solid rgb(204, 204, 204)",
  },
};
const numNeeded = 1;
const numMax = 600;
const numTitles = 2;

const defaultTechnologies = [
  2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27,
];

const Q10_Technologies = ({
  selected,
  setSelected,
  setQuestionsDone,
  questionNum,
  options,
  nextQuestion,
}) => {
  const key2 = `important${questionNum}`;
  // http://localhost:3001/preferences/technologies
  const [searchValue, setSearchValue] = useState("");
  const [technologiesDisplayed, setTechnologiesDisplayed] =
    useState(defaultTechnologies);
  useEffect(() => {
    if (selected[questionNum].includes(1)) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
    } else if (
      selected[questionNum].includes(0) &&
      selected[questionNum].length > 1
    ) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
    } else {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }));
    }
  }, [selected]);
  return (
    <Stack
      direction="column"
      sx={styles.container}
      alignItems="center"
      spacing={0}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack
        direction="column"
        sx={styles.inner}
        alignItems="center"
        justifyContent="center"
        spacing={1}>
        {options.slice(0, numTitles).map((option, i) => {
          return (
            <CheckButton
              key={i}
              text={option}
              selected={selected[questionNum].includes(i)}
              setSelected={() => {
                if (selected[questionNum].includes(i)) {
                  setSelected((s) => {
                    return { ...s, [questionNum]: [], [key2]: [] };
                  });
                } else {
                  setSelected((s) => {
                    return { ...s, [questionNum]: [i], [key2]: [] };
                  });
                  if (i === 1) {
                    setTimeout(nextQuestion, 200);
                  }
                }
                setTechnologiesDisplayed(defaultTechnologies);
              }}
              // disabled={selected[questionNum].length >= numMax && !selected[questionNum].includes(i)}
              noCheck
            />
          );
        })}
      </Stack>
      {selected[questionNum].includes(0) && (
        <Stack
          direction="column"
          sx={styles.inner}
          alignItems="center"
          justifyContent="center"
          spacing={2}>
          <Box sx={{}} />
          {/* <Box sx={{ ...styles.body, fontSize: '0.8rem', paddingBottom: '0.4rem' }}>Tap once if you like them. Tap twice if they're a must-have</Box> */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={0}
            gap={1}
            flexWrap="wrap">
            {options
              .filter((option, idx) => technologiesDisplayed.includes(idx))
              .map((option, idx) => {
                const i = options.indexOf(option);
                return (
                  <HeartButtonTwoStep
                    key={i}
                    text={option}
                    selected={selected[questionNum].includes(i)}
                    selectedTwice={selected[key2].includes(i)}
                    setSelected={() => {
                      if (selected[key2].includes(i)) {
                        // if double selected, remove from both
                        setSelected((s) => {
                          return {
                            ...s,
                            [questionNum]: s[questionNum].filter(
                              (item) => item !== i
                            ),
                            [key2]: s[key2].filter((item) => item !== i),
                          };
                        });
                      } else if (selected[questionNum].includes(i)) {
                        // if single selected, add to double
                        setSelected((s) => {
                          return { ...s, [key2]: [...s[key2], i] };
                        });
                      } else if (selected[questionNum].length < numMax) {
                        // if not selected, add to single
                        setSelected((s) => {
                          return {
                            ...s,
                            [questionNum]: [...s[questionNum], i],
                          };
                        });
                      }
                    }}
                    // disabled={selected[questionNum].length >= numMax && !selected[questionNum].includes(i)}
                  />
                );
              })}
          </Stack>

          <Box sx={{ ...styles.body }}>
            Preferred technology not listed above?
          </Box>

          <Autocomplete
            options={options
              .filter((option, idx) => !technologiesDisplayed.includes(idx))
              .slice(numTitles)}
            getOptionLabel={(option) => option}
            defaultValue={searchValue}
            value={searchValue}
            onChange={(event, newValue) => {
              const i = options.indexOf(newValue);
              setTechnologiesDisplayed([...technologiesDisplayed, i]);
              setSelected((s) => {
                return { ...s, [questionNum]: [...s[questionNum], i] };
              });
              setSearchValue("");
            }}
            sx={{
              width: "100%",
              "& .MuiFormControl-root": {
                border: "none",
              },
            }}
            PaperComponent={CustomPaper}
            renderOption={(props, option, { selected }) => {
              return (
                <li {...props} style={{ textAlign: "center", width: "100%" }}>
                  <Box sx={{ margin: "auto" }}>{option}</Box>
                </li>
              );
            }}
            renderInput={(params) => (
              <StyledTextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
                sx={styles.search}
                variant="standard"
                placeholder="Enter technology here..."
              />
            )}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default Q10_Technologies;
